/**
 * Created by mqamhieh on 6/14/18.
 */
(function () {

    "use strict";

    angular
        .module("userActivation")
        .service("userActivationService", UserActivationService);

    UserActivationService.$inject = ['$state', '$modal', 'hUser', '$q'];

    function UserActivationService($state, $modal, hUser, $q) {
        var userActivationService = this;

        var showActivationSuccess = function () {
            $modal({
                controller: 'UserActivationSuccessModal',
                controllerAs: 'userActivationSuccessModal',
                templateUrl: '../hmodules/user-activation/modals/user-activation-success/user-activation-success.modal.html',
                show: true,
                backdrop: 'static'
            });
        };

        userActivationService.handleUserEmailActivation = function(){
            $modal({
                controller: 'EmailActivationModal',
                controllerAs: '$ctrl',
                templateUrl: '../hmodules/user-activation/modals/email-activation/email-activation.modal.html',
                show: true,
                backdrop: 'static'
            });
        };

        userActivationService.getUserSecondaryInfoByCode = function (code) {
            var defer = $q.defer();
            UserAPI.getUserSecondaryInfoByCode(code).then(function (res) {
                defer.resolve(res);
            }, function (err) {
                defer.reject(err);
            });
            return defer.promise;
        };

        userActivationService.updateUserSecondaryInfo = function (data) {
            var defer = $q.defer();
            UserAPI.updateUserSecondaryInfo(data).then(function (res) {
                defer.resolve(res);
            }, function (err) {
                defer.reject(err);
            });
            return defer.promise;
        };

        userActivationService.handleUserActivation = function () {
            var redirectionState = "homepage";

            hUser.init()
                .then(function () {

                    if (hUser.isLoggedIn()) {
                        redirectionState = "appLayout.harriSH.dashboard";
                    }

                    $state.go(redirectionState)
                        .then(function () {
                            showActivationSuccess();
                        });

                }, function () {
                    $state.go(redirectionState)
                        .then(function () {
                            showActivationSuccess();
                        });
                });

        };

        return userActivationService;
    }

})();